import React, { useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Form, FormGroup, Button, Label, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import {
  postCargoPrice,
  getActiveSalesSession,
  getDetractionAmountBySalePrice,
  clearCargoPrices,
  getCommonProductPrice,
  getParcelPriceConfigurations,
  getCreditNotes,
  clearCreditNotes,
  getDeliveryLocationDistrict,
  clearDeliveryLocationDistrict,
  getCargoCorporateCreditSearch,
  clearCargoCorporateCredit,
} from '../../../../actions';
import {
  isRequired,
  validateNumber,
  validateMaxLength,
  isValidNumber,
  validateLength,
} from '../../../../utils/validators';
import { CARGO_PATH } from '../../../../config/paths';
import {
  ATTACHED_DOCUMENT_PARCEL_COLUMNS,
  generateCargoItemColumns,
} from '../../../../config/dynamicFormFields';
import {
  CONTINGENCY_MOTIVE_OPTION,
  PARCEL_CATEGORY_ENVELOPE,
  VOUCHER_TYPE_BUSINESS_INVOICE_ID,
  VOUCHER_TYPE_INVOICE_ID,
  DEFAULT_ORDER,
  CARGO_PLUS_PRICE_OPTIONS,
} from '../../../../config/constants';
import Alert from '../../../common/informative/Alert';
import Loader from '../../../common/Loader';
import Select from '../../../common/forms/select/Select';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import VoucherTypeSelect from '../../../common/forms/select/VoucherTypeSelect';
import BusinessInputGroup from '../../../common/forms/BusinessInputGroup';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';
import CargoLocationSelect from '../../../common/forms/select/CargoLocationSelect';
import './ParcelForm.css';
import {
  DEFAULT_PARCEL_SERVICE_TYPE_OPTION,
  DEFAULT_VOUCHER_TYPE_OPTION,
} from '../../../../config/defaults';
import ParcelServiceTypeSelect from '../../../common/forms/select/ParcelServiceTypeSelect';
import { isNumber } from '../../../../utils/number';
import Badge from '../../../common/Badge';
import GooglePlacesInput from '../../../common/forms/input/GooglePlacesInput';
import DistrictSelect from '../../../common/forms/select/DistrictSelect';
import {
  clearDiscountCodeSubCategories,
  getDiscountCodeSubCategoriesByDiscountString,
} from '../../../../actions/sales/DiscountCodeSubCategory';
import { getDeliveryPostalCodePriceByDeliveryPostalCode } from '../../../../actions/cargo/DeliveryPostalCodePrice';
import MultiPaymentMethodInputGroup, {
  isPinpadLocked,
} from '../../../common/forms/MultiPaymentMethodInputGroup';

const selector = formValueSelector('ParcelForm');
const validataMaxLength10 = validateMaxLength(10);
const validateLength4 = validateLength(4);
const validataMaxLength9 = validateLength(9);

const validateSecretCode = (confirmSecretCode, { secretCode }) => {
  if (!confirmSecretCode) return undefined;

  return confirmSecretCode !== secretCode
    ? 'Las claves secretas no coinciden'
    : undefined;
};

const isInvalidNumberValue = (item, value) =>
  !item[value] || !isNumber(item[value], 10) || item[value] <= 0;

export const ParcelForm = ({
  prices,
  cargaItemsValues,
  selectedVoucherType,
  senderCustomerValue,
  onSubmit,
  handleSubmit,
  dispatchChange,
  loading,
  loadingCustomerPerson,
  pinpadLocked,
  hasPinpadPayment,
  activeSalesSession,
  gettingActiveSalesSession,
  dispatchPostCargoPrice,
  dispatchClearCargoPrices,
  dispatchGetActiveSalesSession,
  dispatchGetDetractionAmountBySalePrice,
  dispatchGetDiscountCodeSubCategoriesByDiscountString,
  dispatchClearDiscountCodeSubCategories,
  discountCode,
  deliveryAddress,
  dispatchPush,
  cargoCategories,
  parcelServiceTypes,
  customerValue,
  businessValue,
  dispatchGetCommonProductPrice,
  dispatchGetParcelPriceConfigurations,
  dispatchGetDeliveryLocationDistrict,
  parcelPriceConfigurations,
  sourceLocationValue,
  destinationLocationValue,
  dispatchGetCreditNotes,
  dispatchClearCreditNotes,
  creditNotes,
  salePriceValue,
  // salePriceWithDetractionValue,
  salePriceWithDiscountValue,
  deliveryLocationDistrict,
  loadingDeliveryLocationDistrict,
  dispatchClearDeliveryLocationDistrict,
  dispatchGetCargoCorporateCreditSearch,
  cargoCorporateCredit,
  dispatchClearCargoCorporateCredit,
  selectedSourceLocation,
  selectedDestinationLocation,
  discountCodeSubCategories,
  dispatchGetDeliveryPostalCodePriceByDeliveryPostalCode,
}) => {
  const [showDeliveryFields, setShowDeliveryFields] = useState(false);
  const [sourceLocationId, setSourceLocationId] = useState(0);
  const [destinationLocationId, setDestinationLocationId] = useState(0);
  const [parcelServiceTypeId, setParcelServiceTypeId] = useState(0);
  const [showDetraction, setShowDetraction] = useState(false);
  const [detraction, setDetraction] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [isDiscountCodeChecked, setIsDiscountCodeChecked] = useState(false);
  const [showSecondaryConsigneeField, SetShowSecondaryConsigneeField] =
    useState(false);
  const [businessId, setBusinessId] = useState(0);
  const [totaListPrice, setTotaListPrice] = useState(0);
  const [isDocumentListChecked, setIsDocumentListChecked] = useState(false);
  const [showTotalPriceWithDiscount, setShowTotalPriceWithDiscount] =
    useState(false);
  const [hasCreditNoteCode, setHasCreditNoteCode] = useState(false);
  const [showDiscountCheckbox, setShowDiscountCheckbox] = useState(false);
  // const [showDiscountSubCategory, setShowDiscountSubCategory] = useState(false);
  const [disableDestinationSelect, setDisableDestinationSelect] =
    useState(false);

  useLayoutEffect(() => {
    dispatchChange('ParcelForm', 'uuid', crypto.randomUUID());
    dispatchGetActiveSalesSession({ source: CARGO_PATH });
    return () => {
      dispatchChange('ParcelForm', 'uuid', null);
      dispatchClearCargoPrices();
      dispatchClearCreditNotes();
      dispatchClearDeliveryLocationDistrict();
      dispatchClearCargoCorporateCredit();
      dispatchClearDiscountCodeSubCategories();
    };
  }, []);

  const clearSalePrice = async () => {
    dispatchChange('ParcelForm', 'listPrice', '');
    dispatchChange('ParcelForm', 'salePrice', '');
    dispatchChange('ParcelForm', 'discountPrice', '');
    dispatchChange('ParcelForm', 'servicePrice', '');
    dispatchChange('ParcelForm', 'deliveryPrice', '');
  };

  const clearItemMeasures = (index) => {
    dispatchChange('ParcelForm', `cargaItems[${index}].width`, '');
    dispatchChange('ParcelForm', `cargaItems[${index}].height`, '');
    dispatchChange('ParcelForm', `cargaItems[${index}].length`, '');
  };

  useEffect(() => {
    if (
      selectedVoucherType &&
      selectedVoucherType.value !== VOUCHER_TYPE_BUSINESS_INVOICE_ID
    ) {
      setBusinessId(0);
      setDetraction(0);
      setShowDetraction(false);
    }
    clearSalePrice();
    dispatchClearCreditNotes();
    dispatchChange('ParcelForm', 'creditNotes', null);
  }, [selectedVoucherType]);

  useEffect(() => {
    setShowDeliveryFields(false);
    dispatchChange('ParcelForm', 'delivery', false);
    dispatchChange('ParcelForm', 'deliveryAddress', null);
  }, [loadingDeliveryLocationDistrict]);

  useEffect(() => {
    clearSalePrice();
    if (customerValue !== null) {
      const query = [
        `customerId:${customerValue.value}`,
        'isValid:true',
        'previousParcelId:!Ø',
      ];
      dispatchGetCreditNotes({ query });
    }
    if (businessValue !== null) {
      const query = [
        `businessId:${businessValue.value}`,
        'isValid:true',
        'previousParcelId:!Ø',
      ];
      dispatchGetCreditNotes({ query });
    }
  }, [customerValue, businessValue, discountCode]);

  useEffect(() => {
    setShowLoader(gettingActiveSalesSession || activeSalesSession.isEmpty());
    if (!activeSalesSession.isEmpty()) {
      const {
        locationId,
        location: {
          name,
          address: { city },
          receiveCargoPoint,
        },
      } = activeSalesSession.get('agency');
      if (!receiveCargoPoint) {
        toastr.error('Error', 'La agencia no puede recibir carga.');
        dispatchPush(CARGO_PATH);
        return;
      }
      const sourceLocation = { value: locationId, label: name, city };
      setSourceLocationId(locationId);
      dispatchChange('ParcelForm', 'sourceLocation', sourceLocation);
    }
  }, [gettingActiveSalesSession, activeSalesSession]);

  useEffect(() => {
    if (!prices.isEmpty()) {
      const salePriceWithDetraction = prices.get('finalPrice') - detraction;
      dispatchChange('ParcelForm', 'detraction', detraction.toFixed(2));
      dispatchChange(
        'ParcelForm',
        'salePriceWithDetraction',
        salePriceWithDetraction.toFixed(2),
      );
      dispatchChange('ParcelForm', 'servicePrice', prices.get('servicePrice'));
      dispatchChange(
        'ParcelForm',
        'deliveryPrice',
        prices.get('deliveryPrice'),
      );
    }
  }, [detraction, prices]);

  useEffect(() => {
    if (parcelServiceTypes) {
      dispatchChange(
        'ParcelForm',
        'parcelServiceType',
        DEFAULT_PARCEL_SERVICE_TYPE_OPTION,
      );
      setParcelServiceTypeId(DEFAULT_PARCEL_SERVICE_TYPE_OPTION.value);
    }
  }, [parcelServiceTypes]);

  const changeCommonProductList = async () => {
    const customer = customerValue;
    const business = businessValue;
    const sourceLocation = sourceLocationValue;
    const destinationLocation = destinationLocationValue;
    dispatchGetCommonProductPrice({
      sourceLocationId: sourceLocation.value,
      destinationLocationId: destinationLocation.value,
      customerId: customer ? customer.value : null,
      businessId: business ? business.value : null,
    });
  };

  useEffect(() => {
    if (
      sourceLocationId &&
      destinationLocationId &&
      (customerValue || businessValue)
    ) {
      dispatchGetParcelPriceConfigurations();

      if (Array.isArray(cargaItemsValues)) {
        const cleaned = (cargaItemsValues || [])
          .filter((item) => item.commonProductId == null)
          .map((item) => ({ ...item, salePrice: '' }));

        dispatchChange('ParcelForm', 'cargaItems', cleaned);
      }

      clearSalePrice();
      changeCommonProductList();
    }
  }, [customerValue, businessValue, sourceLocationId, destinationLocationId]);

  useEffect(() => {
    if (destinationLocationId && !disableDestinationSelect) {
      dispatchGetDeliveryLocationDistrict({
        locationId: destinationLocationId,
      });
    }
  }, [destinationLocationId]);

  useEffect(() => {
    if (customerValue || businessValue) {
      dispatchClearCargoCorporateCredit();
      dispatchGetCargoCorporateCreditSearch({
        customerId: customerValue ? customerValue.value : null,
        businessId: businessValue ? businessValue.value : null,
      });
    }
  }, [customerValue, businessValue]);

  useEffect(() => {
    if (cargoCorporateCredit.isEmpty()) {
      setShowDiscountCheckbox(true);
      return;
    }

    if (
      !cargoCorporateCredit.isEmpty() &&
      cargoCorporateCredit.toJS().isDiscountAllowed
    ) {
      setShowDiscountCheckbox(true);
      return;
    }

    setShowDiscountCheckbox(false);
  }, [cargoCorporateCredit]);

  useEffect(() => {
    if (deliveryAddress && deliveryAddress.postalCode) {
      (async () => {
        try {
          const deliveryPostalCodePrice =
            await dispatchGetDeliveryPostalCodePriceByDeliveryPostalCode(
              deliveryAddress.postalCode,
            );

          if (!deliveryPostalCodePrice) return;

          dispatchChange('ParcelForm', 'destinationLocation', {
            value: deliveryPostalCodePrice.locationId,
            label: deliveryPostalCodePrice.location.name,
            city: {
              id: deliveryPostalCodePrice.location.cityId,
            },
          });
          setDisableDestinationSelect(true);
          setDestinationLocationId(deliveryPostalCodePrice.locationId);
          clearSalePrice();
        } catch (err) {
          toastr.error(
            'Error',
            'Error al obtener Ubicación relacionada a la dirección de envío',
          );
        }
      })();
    }
  }, [deliveryAddress]);

  useEffect(() => {
    setHasCreditNoteCode(creditNotes.length > 0);
  }, [creditNotes]);

  const calculateTotalListPrice = () => {
    let total = 0;

    prices.get('pricesList').forEach(({ price: { listPrice } }) => {
      total += listPrice;
    });

    dispatchChange('ParcelForm', 'listPrice', total.toFixed(2));
  };

  const calculateTotalSalePrice = async () => {
    const total = prices.get('totalPrice');
    const finalPrice = prices.get('finalPrice');
    const corporateCreditDiscountAmount = prices.get('corporateCreditAmount');
    const listPrice = prices.get('listPrice');

    if (
      selectedVoucherType &&
      selectedVoucherType.value === VOUCHER_TYPE_BUSINESS_INVOICE_ID
    ) {
      const updatedDetraction = await dispatchGetDetractionAmountBySalePrice({
        salePrice: finalPrice,
      });
      setDetraction(updatedDetraction);
      setShowDetraction(updatedDetraction !== 0);
    }

    dispatchChange(
      'ParcelForm',
      'corporateCreditAmount',
      corporateCreditDiscountAmount,
    );

    dispatchChange('ParcelForm', 'salePrice', finalPrice.toFixed(2));
    setTotaListPrice(listPrice);

    if (isDiscountCodeChecked) {
      dispatchChange('ParcelForm', 'salePrice', total.toFixed(2));
      dispatchChange('ParcelForm', 'discountPrice', finalPrice.toFixed(2));
    }

    if (corporateCreditDiscountAmount) {
      setShowTotalPriceWithDiscount(true);
      dispatchChange('ParcelForm', 'salePrice', total.toFixed(2));
      dispatchChange('ParcelForm', 'discountPrice', finalPrice.toFixed(2));
    } else {
      setShowTotalPriceWithDiscount(false);
    }
  };

  const showItemListPrice = () => {
    prices
      .get('pricesList')
      .forEach(({ index, price: { listPrice, salePrice } }) => {
        dispatchChange(
          'ParcelForm',
          `cargaItems[${index}].listPrice`,
          listPrice.toFixed(2),
        );
        dispatchChange(
          'ParcelForm',
          `cargaItems[${index}].salePrice`,
          salePrice,
        );
      });

    calculateTotalListPrice();
    calculateTotalSalePrice();
  };

  useEffect(() => {
    if (!prices.isEmpty()) {
      showItemListPrice();
    }

    if (prices.get('discountCodeString') != null) {
      dispatchGetDiscountCodeSubCategoriesByDiscountString(
        prices.get('discountCodeString'),
        {
          page: 0,
          size: 1000,
          sort: 'id,desc',
          order: DEFAULT_ORDER,
        },
      );
    }
  }, [prices]);

  // const determinateFinalSalePrice = () => {
  //   if (salePriceWithDiscountValue !== null) {
  //     return salePriceWithDiscountValue;
  //   }
  //   if (
  //     salePriceWithDetractionValue !== null &&
  //     salePriceWithDetractionValue !== salePriceValue
  //   ) {
  //     return salePriceWithDetractionValue;
  //   }
  //   return salePriceValue;
  // };

  const determinateFinalSalePrice = () => {
    if (
      salePriceWithDiscountValue !== null &&
      salePriceWithDiscountValue !== ''
    ) {
      return salePriceWithDiscountValue;
    }
    return salePriceValue;
  };

  const reinicializeItemPrices = (index) => {
    dispatchChange('ParcelForm', `cargaItems[${index}].listPrice`, '');
    dispatchChange('ParcelForm', `cargaItems[${index}].salePrice`, '');
    dispatchClearCargoPrices();
  };

  const onClickRemove = (index, fields) => {
    fields.remove(index);
    clearSalePrice();
  };

  const onChangeCategory = (index, payload) => {
    const actualCategory =
      typeof payload === 'object'
        ? payload
        : cargaItemsValues[index].cargoCategoryId;

    if (!actualCategory || !actualCategory.value) return;

    dispatchChange(
      'ParcelForm',
      `cargaItems[${index}].cargoCategoryId`,
      actualCategory,
    );

    const actualCommonProduct = cargaItemsValues[index].commonProductId;

    if (!actualCommonProduct) {
      clearItemMeasures(index);
    }

    const categorySelected = cargoCategories.find(
      (category) => category.id === actualCategory.value,
    );

    if (
      categorySelected.name.toLocaleLowerCase() ===
      PARCEL_CATEGORY_ENVELOPE.toLocaleLowerCase()
    ) {
      dispatchChange('ParcelForm', `cargaItems[${index}].isEnvelope`, true);

      if (parcelPriceConfigurations) {
        const parcelPriceConfiguration = parcelPriceConfigurations.find(
          (config) => !config.cargoCorporateCreditId,
        );

        if (parcelPriceConfiguration) {
          dispatchChange(
            'ParcelForm',
            `cargaItems[${index}].weight`,
            parcelPriceConfiguration.maxEnvelopeWeight,
          );
          dispatchChange(
            'ParcelForm',
            `cargaItems[${index}].length`,
            parcelPriceConfiguration.envelopeLength,
          );
          dispatchChange(
            'ParcelForm',
            `cargaItems[${index}].width`,
            parcelPriceConfiguration.envelopeWidth,
          );
          dispatchChange(
            'ParcelForm',
            `cargaItems[${index}].height`,
            parcelPriceConfiguration.envelopeHeight,
          );
        }
      }
    } else {
      dispatchChange('ParcelForm', `cargaItems[${index}].isEnvelope`, false);
    }
    reinicializeItemPrices(index);
  };

  const onQuantityInputChange = (index) => {
    reinicializeItemPrices(index);
  };

  const clearCommonProduct = (index) => {
    dispatchChange('ParcelForm', `cargaItems[${index}].commonProductId`, null);
    dispatchChange(
      'ParcelForm',
      `cargaItems[${index}].isCommonProductSelected`,
      false,
    );
    clearItemMeasures(index);
    dispatchChange('ParcelForm', `cargaItems[${index}].weight`, '');
    dispatchChange('ParcelForm', `cargaItems[${index}].description`, '');
  };

  const onChangeCommonProduct = (index, payload) => {
    const currentCommonProduct =
      typeof payload === 'object'
        ? payload
        : cargaItemsValues[index].commonProductId;

    if (!currentCommonProduct || !currentCommonProduct.value) return;

    dispatchChange(
      'ParcelForm',
      `cargaItems[${index}].commonProductId`,
      currentCommonProduct,
    );

    dispatchChange('ParcelForm', `cargaItems[${index}].isEnvelope`, false);

    const {
      weight,
      width,
      height,
      length,
      cargoCategoryId,
      productDescription,
    } = currentCommonProduct;

    dispatchChange('ParcelForm', `cargaItems[${index}].weight`, weight);
    dispatchChange('ParcelForm', `cargaItems[${index}].width`, width);
    dispatchChange('ParcelForm', `cargaItems[${index}].height`, height);
    dispatchChange('ParcelForm', `cargaItems[${index}].length`, length);
    dispatchChange(
      'ParcelForm',
      `cargaItems[${index}].description`,
      productDescription,
    );

    const categoryCommonProduct = cargoCategories.find(
      (category) => category.id === cargoCategoryId,
    );

    dispatchChange('ParcelForm', `cargaItems[${index}].cargoCategoryId`, {
      value: categoryCommonProduct.id,
      label: categoryCommonProduct.name,
    });

    if (
      categoryCommonProduct.name.toLocaleLowerCase() ===
      PARCEL_CATEGORY_ENVELOPE.toLocaleLowerCase()
    ) {
      dispatchChange('ParcelForm', `cargaItems[${index}].isEnvelope`, true);
    }

    dispatchChange(
      'ParcelForm',
      `cargaItems[${index}].isCommonProductSelected`,
      true,
    );

    if (currentCommonProduct && currentCommonProduct.price) {
      dispatchChange(
        'ParcelForm',
        `cargaItems[${index}].salePrice`,
        currentCommonProduct.price,
      );
      if (
        cargaItemsValues[index].quantity &&
        isValidNumber(cargaItemsValues[index].quantity) &&
        cargaItemsValues[index].quantity > 0
      ) {
        const total =
          currentCommonProduct.price * cargaItemsValues[index].quantity;
        dispatchChange('ParcelForm', `cargaItems[${index}].salePrice`, total);
      }
    }
  };

  const onCommonProductChange = (index, commonProduct) => {
    clearSalePrice();
    reinicializeItemPrices(index);

    if (!commonProduct.value) {
      clearCommonProduct(index);
      return;
    }

    onChangeCommonProduct(index, commonProduct);
  };

  const onWeightChange = (index) => {
    if (cargaItemsValues[index].commonProductId) return;
    reinicializeItemPrices(index);
  };

  const validateItemValues = (itemsValues) => {
    let isValid = true;
    if (itemsValues.length) {
      const isInvalidData = itemsValues.some((itemValue) => {
        const isEnvelop = !!itemValue.isEnvelope;

        if (isInvalidNumberValue(itemValue, 'quantity')) {
          toastr.error('Error', 'Ingrese una cantidad válida.');
          return true;
        }

        if (!itemValue.cargoCategoryId) {
          toastr.error('Error', 'Seleccione una categoría válida');
          return true;
        }

        if (!itemValue.description) {
          toastr.error('Error', 'Ingrese una descripción válida');
          return true;
        }

        if (isInvalidNumberValue(itemValue, 'weight')) {
          toastr.error('Error', 'Ingrese un peso válido.');
          return true;
        }

        if (isEnvelop) {
          return false;
        }

        if (isInvalidNumberValue(itemValue, 'length')) {
          toastr.error('Error', 'Ingrese un largo válido.');
          return true;
        }

        if (isInvalidNumberValue(itemValue, 'width')) {
          toastr.error('Error', 'Ingrese un ancho válido.');
          return true;
        }

        if (isInvalidNumberValue(itemValue, 'height')) {
          toastr.error('Error', 'Ingrese un alto válido.');
          return true;
        }

        return false;
      });
      isValid = !isInvalidData;
    } else {
      toastr.error('Error', 'Ingrese al menos un item al detalle de carga.');
      isValid = false;
    }
    return isValid;
  };

  const calculateItemListPrice = async (increasedPrice = null) => {
    if (validateItemValues(cargaItemsValues)) {
      dispatchClearCargoPrices();
      const indexes = [];
      const cargoItemList = [];
      cargaItemsValues.forEach((item, index) => {
        const itemToList = {
          quantity: item.quantity,
          weight: item.weight,
          height: item.height,
          width: item.width,
          length: item.length,
          price: item.salePrice,
        };

        if (item.commonProductId) {
          itemToList.commonProductId = item.commonProductId.value;
        }

        if (item.cargoCategoryId) {
          itemToList.categoryId = item.cargoCategoryId.value;
        }

        indexes.push(index);
        cargoItemList.push(itemToList);
      });

      if (showDeliveryFields && !deliveryAddress) {
        toastr.error('Error', 'Seleccione un distrito válido');
        return;
      }

      if (increasedPrice == null) {
        dispatchChange('ParcelForm', 'increasedPrice', null);
      }

      const request = {
        sourceLocationId,
        destinationLocationId,
        cargoItemList,
        parcelServiceTypeId,
        hasDelivery: showDeliveryFields,
        postalCode: deliveryAddress ? deliveryAddress.postalCode : null,
        businessId: businessId > 0 ? businessId : null,
        discountCodeString: isDiscountCodeChecked ? discountCode : null,
        customerId: customerValue ? customerValue.value : null,
        increasedPrice,
        deliveryAddress: deliveryAddress ? deliveryAddress.address : null,
        deliveryLatitude: deliveryAddress ? deliveryAddress.lat : null,
        deliveryLongitude: deliveryAddress ? deliveryAddress.lng : null,
      };

      const response = await dispatchPostCargoPrice(indexes, request);

      if (response === null) {
        clearSalePrice();
      }
    }
  };

  const copySenderToConsignee = () => {
    dispatchChange('ParcelForm', 'consigneeCustomer', senderCustomerValue);
  };
  const copySenderToClient = () => {
    dispatchChange('ParcelForm', 'customer', senderCustomerValue);
  };

  const copyCustomerToSender = () => {
    dispatchChange('ParcelForm', 'senderCustomer', customerValue);
  };

  const handleLocationChange = (location) => {
    setDestinationLocationId(location.value || 0);
    clearSalePrice();
  };

  const handleBusinessChange = (business) => {
    setBusinessId(business.value || 0);
  };

  const handleParcelServiceTypeChange = (parcelServiceType) => {
    setParcelServiceTypeId(parcelServiceType.value || 0);
    clearSalePrice();
  };

  const handleChangeDelivery = ({ target: { checked } }) => {
    setShowDeliveryFields(checked);
    dispatchChange('ParcelForm', 'district', null);
    dispatchChange('ParcelForm', 'deliveryAddress', null);
    dispatchChange('ParcelForm', 'consigneePhoneNumber', null);
    clearSalePrice();
  };

  const validateCargoCorporateCreditSelectedCustomerList =
    !cargoCorporateCredit.isEmpty() &&
    cargoCorporateCredit.toJS().cargoCorporateCreditCityList &&
    cargoCorporateCredit.toJS().cargoCorporateCreditCityList.length > 0;

  const clearSenderAndConsignee = () => {
    dispatchChange('ParcelForm', 'senderCustomer', '');
    dispatchChange('ParcelForm', 'consigneeCustomer', '');
  };

  useEffect(() => {
    if (validateCargoCorporateCreditSelectedCustomerList) {
      clearSenderAndConsignee();
    }
  }, [validateCargoCorporateCreditSelectedCustomerList]);

  const getCargoCorporateCreditConsigneeList = () => {
    if (
      validateCargoCorporateCreditSelectedCustomerList &&
      destinationLocationValue
    ) {
      const customerCityList = cargoCorporateCredit
        .toJS()
        .cargoCorporateCreditCityList.find(
          (element) => element.cityId === destinationLocationValue.city.id,
        );

      if (customerCityList) {
        return customerCityList.customerList
          .filter(
            (customer) =>
              customer.customerType === 'SENDER_CONSIGNEE' ||
              customer.customerType === 'CONSIGNEE',
          )
          .map((element) => ({
            value: element.customer.id,
            label: element.customer.fullName,
          }));
      }
    }
    return [];
  };

  const getCargoCorporateCreditSenderList = () => {
    if (
      validateCargoCorporateCreditSelectedCustomerList &&
      sourceLocationValue
    ) {
      const customerCityList = cargoCorporateCredit
        .toJS()
        .cargoCorporateCreditCityList.find(
          (element) => element.cityId === sourceLocationValue.city.id,
        );

      if (customerCityList) {
        return customerCityList.customerList
          .filter(
            (customer) =>
              customer.customerType === 'SENDER_CONSIGNEE' ||
              customer.customerType === 'SENDER',
          )
          .map((element) => ({
            value: element.customer.id,
            label: element.customer.fullName,
          }));
      }
    }
    return [];
  };

  const renderDeliveryFields = () =>
    !showDeliveryFields ? null : (
      <>
        <FormGroup row>
          <FormItem label="Dirección de Entrega" required>
            <Field name="deliveryAddress" component={GooglePlacesInput} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Distrito de entrega" required>
            <Field name="district" component={DistrictSelect} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Celular Consignado" required>
            <Field
              name="consigneePhoneNumber"
              component={TextInput}
              type="text"
              validate={[isRequired, validataMaxLength9, validateNumber]}
            />
          </FormItem>
        </FormGroup>
      </>
    );

  const renderDynamicForm = () => {
    if (sourceLocationId === 0 || destinationLocationId === 0) {
      return <Alert message="Seleccione Origen y Destino" />;
    }
    if (loading) {
      return <Loader />;
    }
    return (
      <DynamicForm
        name="cargaItems"
        columns={generateCargoItemColumns(
          onQuantityInputChange,
          onCommonProductChange,
          onWeightChange,
          onChangeCategory,
          onChangeCommonProduct,
        )}
        onClickRemove={onClickRemove}
      />
    );
  };

  const renderCalculatePriceButton = () => {
    if (
      sourceLocationId === 0 ||
      destinationLocationId === 0 ||
      cargaItemsValues.length === 0
    ) {
      return null;
    }
    return (
      <div className="mt-2 mb-3">
        <ButtonToolbar className="flex row-reverse">
          <div>
            <Button
              type="button"
              outline
              color="primary"
              onClick={() => calculateItemListPrice()}
            >
              Calcular precio
            </Button>
          </div>
        </ButtonToolbar>
      </div>
    );
  };

  const renderDetraction = () => {
    const detractionField = showDetraction ? (
      <>
        <FormGroup row>
          <FormItem label="Detracción">
            <Field
              name="detraction"
              component={TextInput}
              type="text"
              placeholder="Detracción"
              disabled
              validate={[validateNumber]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Precio Total de Venta con Detracción">
            <Field
              name="salePriceWithDetraction"
              component={TextInput}
              type="text"
              placeholder="Precio Total de Venta con Detracción"
              disabled
              validate={[validateNumber]}
            />
          </FormItem>
        </FormGroup>
      </>
    ) : null;
    return detractionField;
  };

  const renderClient = () => {
    if (
      selectedVoucherType &&
      selectedVoucherType.value === VOUCHER_TYPE_BUSINESS_INVOICE_ID
    ) {
      dispatchChange('ParcelForm', 'customer', '');
      return (
        <BusinessInputGroup
          label="Empresa"
          labelRequired
          name="business"
          form="ParcelForm"
          validate={[isRequired]}
          showDetails
          onChange={(option) => handleBusinessChange(option)}
        />
      );
    }
    dispatchChange('ParcelForm', 'business', '');
    return (
      <CustomerInputGroup
        label="Cliente"
        labelRequired
        name="customer"
        form="ParcelForm"
        validate={[isRequired]}
        showDetails
        useBookingSearch
        canEditNames
      />
    );
  };

  const handleDiscountCodeChange = (isChecked) => {
    clearSalePrice();
    if (isChecked) {
      setIsDiscountCodeChecked(true);
      return;
    }
    setIsDiscountCodeChecked(false);
    dispatchChange('ParcelForm', 'discountCode', '');
  };

  const renderCopySenderToButton = () => {
    if (!senderCustomerValue) {
      return null;
    }
    const copyButton = (action, className) =>
      action === copySenderToConsignee && (
        <Button
          type="button"
          className={className}
          outline
          color="primary"
          onClick={action}
          disabled={loadingCustomerPerson}
        >
          Copiar Consignado
        </Button>
      );
    return selectedVoucherType &&
      selectedVoucherType.value === VOUCHER_TYPE_BUSINESS_INVOICE_ID ? (
      <FormGroup row>
        <FormItem>{copyButton(copySenderToConsignee)}</FormItem>
      </FormGroup>
    ) : (
      <>
        <FormGroup row>
          <FormItem>{copyButton(copySenderToConsignee)}</FormItem>
        </FormGroup>
        <FormGroup row>{copyButton(copySenderToClient)}</FormGroup>
      </>
    );
  };

  const renderCopyCustomerToButton = () => {
    if (!customerValue) {
      return null;
    }
    const copyButton = (action, className) =>
      action === copyCustomerToSender && (
        <Button
          type="button"
          className={className}
          outline
          color="primary"
          onClick={action}
          disabled={loadingCustomerPerson}
        >
          Copiar Cliente
        </Button>
      );
    return (
      selectedVoucherType &&
      selectedVoucherType.value === VOUCHER_TYPE_INVOICE_ID && (
        <FormGroup row>
          <FormItem>{copyButton(copyCustomerToSender)}</FormItem>
        </FormGroup>
      )
    );
  };

  const onHandleSubmit = (formValues) => {
    if (validateItemValues(cargaItemsValues)) {
      onSubmit(
        formValues,
        showDeliveryFields,
        isDiscountCodeChecked,
        totaListPrice,
        determinateFinalSalePrice(),
        prices.get('netDiscountAmount'),
        discountCodeSubCategories,
        prices.get('yangoPrice'),
      );
    }
  };

  const renderSecondaryConsigneeFields = () =>
    showSecondaryConsigneeField &&
    (validateCargoCorporateCreditSelectedCustomerList ? (
      <FormGroup row>
        <FormItem label="Consignado Secundario" required>
          <Field
            name="secondaryConsigneeCustomer"
            component={Select}
            options={getCargoCorporateCreditConsigneeList()}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
    ) : (
      <CustomerInputGroup
        label="Consignado Secundario"
        labelRequired
        name="secondaryConsigneeCustomer"
        form="ParcelForm"
        validate={[isRequired]}
        showDetails
        useBookingSearch
      />
    ));

  const renderContingencyFields = () => {
    let isContingencySalesSession = false;

    if (!activeSalesSession.isEmpty()) {
      isContingencySalesSession =
        activeSalesSession.get('workstation').contingency;
    }
    const contingencyField = isContingencySalesSession ? (
      <>
        <h5>Datos de Contingencia</h5>
        <FormGroup row>
          <FormItem label="Serie de Contingencia" required>
            <Field
              name="contingencyDocumentSeries"
              component={TextInput}
              type="text"
              placeholder="Serie de Contingencia"
              validate={
                isContingencySalesSession
                  ? [isRequired, validateNumber, validateLength4]
                  : []
              }
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Código de Contingencia" required>
            <Field
              name="contingencyDocumentCode"
              component={TextInput}
              type="text"
              placeholder="Código de Contingencia"
              validate={
                isContingencySalesSession ? [isRequired, validateNumber] : []
              }
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Motivo de Contingencia" required>
            <Field
              name="contingencyMotive"
              component={Select}
              placeholder="Motivo de Contingencia"
              options={CONTINGENCY_MOTIVE_OPTION}
              validate={isContingencySalesSession ? [isRequired] : []}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Fecha de Venta" required>
            <Field
              name="contingencyAssignmentDocumentDate"
              component={TextInput}
              type="datetime-local"
              placeholder="Fecha de Venta"
              validate={isContingencySalesSession ? [isRequired] : []}
            />
          </FormItem>
        </FormGroup>
      </>
    ) : null;
    return contingencyField;
  };

  if (showLoader) {
    return <Loader />;
  }
  const renderRelationDocumentFields = () => {
    const bussinessVoucher =
      selectedVoucherType &&
      selectedVoucherType.value === VOUCHER_TYPE_BUSINESS_INVOICE_ID;

    return (
      <>
        {bussinessVoucher && (
          <FormGroup row>
            <FormItem>
              <Label>
                <Field
                  name="isRelationDocumentList"
                  id="isRelationDocumentList"
                  component="input"
                  type="checkbox"
                  onChange={(e) => setIsDocumentListChecked(e.target.checked)}
                />{' '}
                Agregar Listado de documentos Relacionados
              </Label>
            </FormItem>
          </FormGroup>
        )}

        {!isDocumentListChecked && (
          <FormGroup row>
            <FormItem label="Documento Relacionado">
              <Field
                name="attachedDocument"
                component={TextInput}
                type="text"
                placeholder="Guia Remisión y/o Factura"
              />
            </FormItem>
          </FormGroup>
        )}

        {isDocumentListChecked && bussinessVoucher && (
          <DynamicForm
            name="attachedDocuments"
            columns={ATTACHED_DOCUMENT_PARCEL_COLUMNS}
          />
        )}
      </>
    );
  };

  let creditNoteResource;

  if (hasCreditNoteCode && customerValue !== null) {
    creditNoteResource = (
      <div className="text-center">
        <Badge color="success" text="Este cliente tiene una nota de crédito" />
      </div>
    );
  } else if (hasCreditNoteCode && businessValue !== null) {
    creditNoteResource = (
      <div className="text-center">
        <Badge color="success" text="Esta empresa tiene una nota de crédito" />
      </div>
    );
  }

  let cargoCorporateCreditResource = null;
  if (validateCargoCorporateCreditSelectedCustomerList) {
    cargoCorporateCreditResource = (
      <div className="text-center mb-2">
        <Badge
          color="success"
          text="Esta Empresa/Cliente tiene crédito corporativo con Remitentes y Consignados previamente definidos"
        />
      </div>
    );
  }

  let deliveryComponent = null;

  if (
    !deliveryLocationDistrict.isEmpty() &&
    deliveryLocationDistrict.get('districtPostalCodeList').length > 0
  ) {
    deliveryComponent = (
      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="delivery"
              id="delivery"
              component="input"
              type="checkbox"
              onChange={handleChangeDelivery}
            />{' '}
            Entrega a Domicilio
          </Label>
        </FormItem>
      </FormGroup>
    );
  }

  if (loadingDeliveryLocationDistrict) {
    deliveryComponent = <Loader />;
  }

  const onChangeIncreasedPrice = (selected) => {
    const increasedPrice = selected ? selected.value : null;
    calculateItemListPrice(increasedPrice);
  };

  const showIncreasedPriceField =
    !isDiscountCodeChecked && salePriceValue != null;

  const renderIncreasedPriceField = showIncreasedPriceField && (
    <>
      <FormGroup row>
        <FormItem label="IP">
          <Field
            name="increasedPrice"
            component={Select}
            isClearable
            options={CARGO_PLUS_PRICE_OPTIONS}
            onChange={(option) => onChangeIncreasedPrice(option)}
            placeholder="IP"
          />
        </FormItem>
      </FormGroup>
    </>
  );

  return (
    <>
      <Form onSubmit={handleSubmit(onHandleSubmit)}>
        <FormGroup row className="d-none">
          <FormItem>
            <Field name="uuid" component={TextInput} disabled type="text" />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tipo de Comprobante" required>
            <Field
              name="voucherType"
              component={VoucherTypeSelect}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tipo de Servicio" required>
            <Field
              name="parcelServiceType"
              component={ParcelServiceTypeSelect}
              validate={[isRequired]}
              onChange={(option) => handleParcelServiceTypeChange(option)}
            />
          </FormItem>
        </FormGroup>
        <h5>Datos de Envio</h5>
        <FormGroup row>
          <FormItem label="Origen" required>
            <Field
              name="sourceLocation"
              component={CargoLocationSelect}
              isDisabled
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Destino" required>
            <Field
              name="destinationLocation"
              component={CargoLocationSelect}
              onChange={handleLocationChange}
              isDisabled={disableDestinationSelect}
              validate={[isRequired]}
              forPickupCargo
            />
          </FormItem>
        </FormGroup>
        {deliveryComponent}
        {renderDeliveryFields()}
        <h5>Datos del Cliente</h5>
        {renderClient()}
        {creditNoteResource}
        {cargoCorporateCreditResource}
        <h5>Datos del Remitente y Consignado</h5>
        {validateCargoCorporateCreditSelectedCustomerList ? (
          <>
            {selectedSourceLocation && selectedDestinationLocation ? (
              <>
                <FormGroup row>
                  <FormItem label="Remitente" required>
                    <Field
                      name="senderCustomer"
                      options={getCargoCorporateCreditSenderList()}
                      component={Select}
                      validate={[isRequired]}
                      noOptionsMessage={() =>
                        'No hay remitentes disponibles para esta Ciudad del Corporativo'
                      }
                    />
                  </FormItem>
                </FormGroup>
                <FormGroup row>
                  <FormItem label="Consignado" required>
                    <Field
                      name="consigneeCustomer"
                      options={getCargoCorporateCreditConsigneeList()}
                      component={Select}
                      validate={[isRequired]}
                      noOptionsMessage={() =>
                        'No hay consignados disponibles para esta Ciudad del Corporativo'
                      }
                    />
                  </FormItem>
                </FormGroup>
              </>
            ) : (
              <Alert message="Seleccione Origen y Destino" />
            )}
          </>
        ) : (
          <>
            {renderCopyCustomerToButton()}
            <CustomerInputGroup
              label="Remitente"
              labelRequired
              name="senderCustomer"
              form="ParcelForm"
              validate={[isRequired]}
              showDetails
              useBookingSearch
              canEditNames
            />
            {renderCopySenderToButton()}
            <CustomerInputGroup
              label="Consignado"
              labelRequired
              name="consigneeCustomer"
              form="ParcelForm"
              validate={[isRequired]}
              showDetails
              useBookingSearch
              canEditNames
            />
          </>
        )}
        <FormGroup row>
          <FormItem>
            <Label>
              <Field
                name="secondaryConsignee"
                id="secondaryConsignee"
                component="input"
                type="checkbox"
                onChange={(e) =>
                  SetShowSecondaryConsigneeField(e.target.checked)
                }
              />{' '}
              Agregar Consignado Secundario
            </Label>
          </FormItem>
        </FormGroup>
        {renderSecondaryConsigneeFields()}
        <h5>Detalle de Carga</h5>
        {renderDynamicForm()}
        {renderIncreasedPriceField}
        {renderCalculatePriceButton()}
        <h5>Datos de Pago</h5>
        {cargaItemsValues.length > 0 && (
          <>
            {showDiscountCheckbox && (
              <FormGroup row>
                <FormItem>
                  <Label>
                    <Field
                      name="discount"
                      id="discount"
                      component="input"
                      type="checkbox"
                      onChange={(e) =>
                        handleDiscountCodeChange(e.target.checked)
                      }
                    />{' '}
                    Aplicar Descuento
                  </Label>
                </FormItem>
              </FormGroup>
            )}
            <FormGroup row>
              <FormItem label="Código de Descuento">
                <Field
                  name="discountCode"
                  component={TextInput}
                  type="text"
                  placeholder="Código de Descuento"
                  disabled={!isDiscountCodeChecked}
                  validate={isDiscountCodeChecked ? [isRequired] : []}
                />
              </FormItem>
            </FormGroup>
            <FormGroup row>
              <FormItem label="Servicio de Carga">
                <Field
                  name="servicePrice"
                  component={TextInput}
                  type="text"
                  placeholder="Precio por Servicio de Carga"
                  disabled
                  validate={[validateNumber]}
                />
              </FormItem>
            </FormGroup>
            {showDeliveryFields && (
              <FormGroup row>
                <FormItem label="Servicio de Reparto">
                  <Field
                    name="deliveryPrice"
                    component={TextInput}
                    type="text"
                    placeholder="Precio por Reparto"
                    disabled
                    validate={[validateNumber]}
                  />
                </FormItem>
              </FormGroup>
            )}
          </>
        )}
        <FormGroup row>
          <FormItem label="Precio Total de Venta">
            <Field
              name="salePrice"
              component={TextInput}
              type="text"
              placeholder="Precio Total de Venta"
              disabled
              validate={[isRequired, validateNumber]}
            />
          </FormItem>
        </FormGroup>
        {(isDiscountCodeChecked || showTotalPriceWithDiscount) && (
          <>
            <FormGroup row>
              <FormItem label="Precio Total con Descuento">
                <Field
                  name="discountPrice"
                  component={TextInput}
                  type="text"
                  placeholder="Precio Total con Descuento"
                  disabled
                  validate={[isRequired, validateNumber]}
                />
              </FormItem>
            </FormGroup>
          </>
        )}
        {renderDetraction()}
        {/* keep mounted while a pinpad charge exists: remounting resets the rows and loses the payment */}
        {((salePriceValue && parseFloat(salePriceValue) > 0) ||
          hasPinpadPayment ||
          pinpadLocked) && (
          <FormGroup row>
            <FormItem label="Método de pagos" required>
              <MultiPaymentMethodInputGroup
                formName="ParcelForm"
                totalPrice={parseFloat(determinateFinalSalePrice()) || 0}
              />
            </FormItem>
          </FormGroup>
        )}
        {renderContingencyFields()}
        <h5>Datos de Seguridad</h5>
        <FormGroup row>
          <FormItem label="Clave Secreta" required>
            <Field
              className="password"
              name="secretCode"
              component={TextInput}
              type="text"
              placeholder="Clave Secreta"
              validate={[isRequired, validateNumber, validataMaxLength10]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Confirmar Clave Secreta" required>
            <Field
              className="password"
              name="confirmSecretCode"
              component={TextInput}
              type="text"
              placeholder="Confirmar Clave Secreta"
              validate={[
                isRequired,
                validateNumber,
                validataMaxLength10,
                validateSecretCode,
              ]}
            />
          </FormItem>
        </FormGroup>
        <h5>Datos de Adicionales</h5>
        {renderRelationDocumentFields()}
        <FormGroup row>
          <FormItem label="Nota">
            <Field
              name="note"
              component={TextInput}
              type="textarea"
              placeholder="Nota"
            />
          </FormItem>
        </FormGroup>
        <FormFooter
          saveButtonDisabled={loading || loadingCustomerPerson || pinpadLocked}
          saveButtonIcon={
            loading || loadingCustomerPerson
              ? 'fa fa-spinner fa-spin'
              : 'fa fa-save'
          }
        />
      </Form>
    </>
  );
};

ParcelForm.propTypes = {
  prices: PropTypes.instanceOf(Immutable.Map).isRequired,
  cargaItemsValues: PropTypes.instanceOf(Array),
  selectedVoucherType: PropTypes.instanceOf(Object),
  senderCustomerValue: PropTypes.instanceOf(Object),
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loadingCustomerPerson: PropTypes.bool,
  pinpadLocked: PropTypes.bool.isRequired,
  hasPinpadPayment: PropTypes.bool.isRequired,
  activeSalesSession: PropTypes.instanceOf(Immutable.Map).isRequired,
  gettingActiveSalesSession: PropTypes.bool.isRequired,
  dispatchPostCargoPrice: PropTypes.func.isRequired,
  dispatchClearCargoPrices: PropTypes.func.isRequired,
  dispatchGetActiveSalesSession: PropTypes.func.isRequired,
  dispatchGetDetractionAmountBySalePrice: PropTypes.func.isRequired,
  discountCode: PropTypes.string,
  dispatchPush: PropTypes.func.isRequired,
  cargoCategories: PropTypes.instanceOf(Array).isRequired,
  parcelServiceTypes: PropTypes.instanceOf(Array).isRequired,
  customerValue: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  businessValue: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  dispatchGetCommonProductPrice: PropTypes.func.isRequired,
  dispatchGetParcelPriceConfigurations: PropTypes.func.isRequired,
  dispatchGetDeliveryLocationDistrict: PropTypes.func.isRequired,
  dispatchClearDeliveryLocationDistrict: PropTypes.func.isRequired,
  parcelPriceConfigurations: PropTypes.instanceOf(Array).isRequired,
  sourceLocationValue: PropTypes.instanceOf(Object),
  destinationLocationValue: PropTypes.instanceOf(Object),
  // dispatchGetCargoCorporateCreditCitiesByLocationAndCustomer:
  //   PropTypes.func.isRequired,
  dispatchGetCreditNotes: PropTypes.func.isRequired,
  dispatchClearCreditNotes: PropTypes.func.isRequired,
  creditNotes: PropTypes.instanceOf(Array),
  salePriceValue: PropTypes.string,
  // salePriceWithDetractionValue: PropTypes.string,
  salePriceWithDiscountValue: PropTypes.string,
  deliveryAddress: PropTypes.shape({
    address: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    postalCode: PropTypes.string,
  }),
  deliveryLocationDistrict: PropTypes.instanceOf(Immutable.Map).isRequired,
  loadingDeliveryLocationDistrict: PropTypes.bool,
  dispatchGetCargoCorporateCreditSearch: PropTypes.func.isRequired,
  cargoCorporateCredit: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchClearCargoCorporateCredit: PropTypes.func.isRequired,
  dispatchGetDeliveryPostalCodePriceByDeliveryPostalCode:
    PropTypes.func.isRequired,
  selectedSourceLocation: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
    city: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }),
  selectedDestinationLocation: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
    city: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }),
  discountCodeSubCategories: PropTypes.instanceOf(Array),
  dispatchGetDiscountCodeSubCategoriesByDiscountString:
    PropTypes.func.isRequired,
  dispatchClearDiscountCodeSubCategories: PropTypes.func.isRequired,
};

ParcelForm.defaultProps = {
  cargaItemsValues: [],
  selectedVoucherType: null,
  senderCustomerValue: null,
  loading: false,
  loadingCustomerPerson: false,
  discountCode: null,
  customerValue: null,
  businessValue: null,
  creditNotes: [],
  deliveryAddress: null,

  salePriceValue: null,
  // salePriceWithDetractionValue: null,
  salePriceWithDiscountValue: null,
  sourceLocationValue: null,
  destinationLocationValue: null,

  loadingDeliveryLocationDistrict: false,
  selectedSourceLocation: null,
  selectedDestinationLocation: null,
  discountCodeSubCategories: [],
};

const mapStateToProps = (state) => {
  const rawSubcats = state.SalesUnit.DiscountCodeSubCategory.getIn([
    'all',
    'content',
    'content',
  ]);

  const discountCodeSubCategories = rawSubcats.map((subCategory) => ({
    value: subCategory.id,
    label: subCategory.name,
  }));

  const selectedSubcatField = selector(state, 'discountCodeSubCategory');
  const chosenSubcatId =
    (selectedSubcatField && selectedSubcatField.value) ||
    (discountCodeSubCategories.length === 1
      ? discountCodeSubCategories[0].value
      : null);

  let subCategoryAuthorizers = [];
  if (chosenSubcatId) {
    const sc = rawSubcats.find((s) => s.id === chosenSubcatId);
    if (sc && Array.isArray(sc.discountCodeSubCategoryAuthorizerList)) {
      subCategoryAuthorizers = sc.discountCodeSubCategoryAuthorizerList
        .filter((a) => a.active !== false)
        .map((a) => {
          const auth = a.discountCodeAuthorizer;
          const label =
            auth && auth.customer && auth.customer.fullName
              ? auth.customer.fullName
              : `Autorizador ${a.discountCodeAuthorizerId}`;
          return {
            value: a.discountCodeAuthorizerId,
            label,
          };
        });
    }
  }

  return {
    loading: !state.CargoUnit.Cargo.getIn(['current', 'activity']).isEmpty(),
    loadingCustomer: !state.UserUnit.Customer.getIn([
      'current',
      'activity',
    ]).isEmpty(),
    loadingCustomerPerson: state.UserUnit.Customer.getIn(['all', 'loading']),
    cargaItemsValues: selector(state, 'cargaItems'),
    salePriceValue: selector(state, 'salePrice'),
    selectedVoucherType: selector(state, 'voucherType'),
    senderCustomerValue: selector(state, 'senderCustomer'),
    consigneeCustomerValue: selector(state, 'consigneeCustomer'),
    customerValue: selector(state, 'customer'),
    businessValue: selector(state, 'business'),
    sourceLocationValue: selector(state, 'sourceLocation'),
    destinationLocationValue: selector(state, 'destinationLocation'),
    prices: state.CargoUnit.Cargo.getIn(['current', 'price']),
    gettingActiveSalesSession: state.SalesUnit.SalesSession.getIn([
      'active',
      'loading',
    ]),
    activeSalesSession: state.SalesUnit.SalesSession.getIn([
      'active',
      'content',
    ]),
    commonProducts: state.CargoUnit.CommonProduct.getIn([
      'current',
      'price',
    ]).toJS(),
    discountCode: selector(state, 'discountCode'),
    cargoCategories: state.CargoUnit.CargoCategory.getIn([
      'all',
      'content',
      'content',
    ]),
    parcelServiceTypes: state.CargoUnit.ParcelServiceType.getIn([
      'all',
      'content',
      'content',
    ]),
    commonProductPrices: state.CargoUnit.CommonProduct.getIn([
      'current',
      'price',
    ]).toJS(),
    parcelPriceConfigurations: state.CargoUnit.ParcelPriceConfiguration.getIn([
      'all',
      'content',
      'content',
    ]),
    creditNotes: state.SalesUnit.CreditNote.getIn([
      'all',
      'content',
      'content',
    ]),

    salePriceWithDiscountValue: selector(state, 'discountPrice'),
    salePriceWithDetractionValue: selector(state, 'salePriceWithDetraction'),

    deliveryAddress: selector(state, 'deliveryAddress'),
    deliveryLocationDistrict: state.CargoUnit.DeliveryLocationDistrict.getIn([
      'current',
      'content',
    ]),
    loadingDeliveryLocationDistrict:
      !state.CargoUnit.DeliveryLocationDistrict.getIn([
        'current',
        'activity',
      ]).isEmpty(),
    cargoCorporateCredit: state.CorporateUnit.CargoCorporateCredit.getIn([
      'current',
      'content',
    ]),
    selectedSourceLocation: selector(state, 'sourceLocation'),
    selectedDestinationLocation: selector(state, 'destinationLocation'),

    discountCodeSubCategories,
    subCategoryAuthorizers,
    pinpadLocked: isPinpadLocked('ParcelForm')(state),
    hasPinpadPayment: (selector(state, 'transactionList') || []).some(
      (transaction) => transaction && transaction.pinpadPaid,
    ),
  };
};

const mapDispatchToProps = {
  dispatchChange: change,
  dispatchPostCargoPrice: postCargoPrice,
  dispatchClearCargoPrices: clearCargoPrices,
  dispatchGetActiveSalesSession: getActiveSalesSession,
  dispatchGetDetractionAmountBySalePrice: getDetractionAmountBySalePrice,
  dispatchPush: push,
  dispatchGetCommonProductPrice: getCommonProductPrice,
  dispatchGetParcelPriceConfigurations: getParcelPriceConfigurations,
  dispatchGetCreditNotes: getCreditNotes,
  dispatchClearCreditNotes: clearCreditNotes,
  dispatchGetDeliveryLocationDistrict: getDeliveryLocationDistrict,
  dispatchClearDeliveryLocationDistrict: clearDeliveryLocationDistrict,
  dispatchGetCargoCorporateCreditSearch: getCargoCorporateCreditSearch,
  dispatchClearCargoCorporateCredit: clearCargoCorporateCredit,
  dispatchGetDiscountCodeSubCategoriesByDiscountString:
    getDiscountCodeSubCategoriesByDiscountString,
  dispatchClearDiscountCodeSubCategories: clearDiscountCodeSubCategories,
  dispatchGetDeliveryPostalCodePriceByDeliveryPostalCode:
    getDeliveryPostalCodePriceByDeliveryPostalCode,
};

const formComponent = reduxForm({
  form: 'ParcelForm',
  initialValues: {
    voucherType: DEFAULT_VOUCHER_TYPE_OPTION,
  },
})(ParcelForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
